import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
		gap: 4,
	},
	chip: {
		maxWidth: "100%",
		border: "none",
	},
	option: {
		display: "flex",
		alignItems: "center",
		gap: 8,
		minWidth: 0,
	},
	dot: {
		flex: "none",
		width: 10,
		height: 10,
		borderRadius: "50%",
		boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.12)",
	},
}));

export const queueMenuProps = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "left",
	},
	getContentAnchorEl: null,
};

/** Selo com a cor da fila (cor de DADO): o texto usa o contraste calculado, não uma cor fixa. */
export const QueueChip = ({ queue, className, ...rest }) => {
	const classes = useStyles();
	const theme = useTheme();
	let style;
	if (queue.color) {
		try {
			style = {
				backgroundColor: queue.color,
				color: theme.palette.getContrastText(queue.color),
			};
		} catch (e) {
			// cor inválida no cadastro: fica o selo neutro do tema
		}
	}
	return (
		<Chip
			size="small"
			style={style}
			label={queue.name}
			className={[classes.chip, className].filter(Boolean).join(" ")}
			{...rest}
		/>
	);
};

/** Item do menu: bolinha com a cor da fila + nome. */
export const QueueOptionLabel = ({ queue }) => {
	const classes = useStyles();
	return (
		<span className={classes.option}>
			<span
				className={classes.dot}
				style={{ backgroundColor: queue.color || "transparent" }}
				aria-hidden="true"
			/>
			{queue.name}
		</span>
	);
};

// `margin="none"` é para quem hospeda o campo numa grade (sem o respiro legado de 6 px + dense).
const QueueSelect = ({ selectedQueueIds, onChange, margin = "dense" }) => {
	const classes = useStyles();
	const [queues, setQueues] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={margin === "none" ? undefined : { marginTop: 6 }}>
			<FormControl fullWidth margin={margin} variant="outlined">
				<InputLabel id="queue-select-label">{i18n.t("queueSelect.inputLabel")}</InputLabel>
				<Select
					multiple
					labelId="queue-select-label"
					label={i18n.t("queueSelect.inputLabel")}
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={queueMenuProps}
					renderValue={selected => (
						<div className={classes.chips}>
							{selected?.length > 0 &&
								selected.map(id => {
									const queue = queues.find(q => q.id === id);
									return queue ? <QueueChip key={id} queue={queue} /> : null;
								})}
						</div>
					)}
				>
					{queues.map(queue => (
						<MenuItem key={queue.id} value={queue.id}>
							<QueueOptionLabel queue={queue} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default QueueSelect;
